import { TODAY, DAYS_IN_WEEK, DAYS_IN_4_WEEKS } from '@/constants/global';
import { i18n } from '@/lang';

export const SCORES = [
    { id: 'ets', name: i18n.t('ets') },
    { id: 'foster', name: i18n.t('foster') },
    { id: 'trimp', name: i18n.t('trimp') },
    { id: 'rpe', name: i18n.t('rpe') },
    { id: 'trainingZoneDistribution', name: i18n.t('trainingZoneDistribution') }
];

export const DATES = [
    { value: TODAY, name: i18n.t('today') },
    { value: DAYS_IN_WEEK, name: i18n.t('lastWeek') },
    { value: DAYS_IN_4_WEEKS, name: i18n.t('last4Weeks') }
];

export const widgetTrainingDistribution = {
    namespaced: true,

    state: {
        selectedScore: SCORES[4],
        selectedSquad: null,
        selectedDate: DATES[0]
    },

    getters: {
        selectedDate(state) {
            return state.selectedDate;
        },

        selectedScore(state) {
            return state.selectedScore;
        },

        selectedSquad(state) {
            return state.selectedSquad;
        }
    },

    mutations: {
        reset(state) {
            state.selectedDate = DATES[0];
            state.selectedScore = SCORES[0];
            state.selectedSquad = null;
        },

        updateDate(state, date) {
            state.selectedDate = date;
        },

        updateScore(state, score) {
            state.selectedScore = score;
        },

        updateSelectedSquad(state, squad) {
            state.selectedSquad = squad;
        }
    }
};

export default widgetTrainingDistribution;
